/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CompanyDailyNavConfigComp = {
  comp_type: CompanyDailyNavConfigComp.comp_type;
  cap_iq_id: string;
  ticker_symbol: string;
  company_name: string;
  order: number;
};
export namespace CompanyDailyNavConfigComp {
  export enum comp_type {
    PUBLIC_COMP = 'public_comp',
    ETF = 'etf',
  }
}
